export const GET_JOBS = "GET_JOBS";
export const ADD_JOBS = "ADD_JOBS";
export const APPROVE_JOBS = "APPROVE_JOBS";
export const UPDATE_JOBS = "UPDUPDATE_JOBSATE_CLIENT";
export const DELETE_JOBS = "DELETE_JOBS";
